import { render } from "./NovaFamilia.vue?vue&type=template&id=c9e6990c"
import script from "./NovaFamilia.vue?vue&type=script&lang=js"
export * from "./NovaFamilia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__